export const uniqueValuesArray = (array: any[]) => Array.from(new Set(array))
